var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.652,
    height: 22.646,
    viewBox: "0 0 22.652 22.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.308,12.089a5.973,5.973,0,0,0,3.3.989,6.039,6.039,0,1,0-5.224-9.058H1.755a.755.755,0,1,0,0,1.51h.8c.309,2.846,2.34,4.537,3.993,5.918,1.072.891,2,1.661,2,2.385s-.928,1.495-2,2.385C4.9,17.6,2.864,19.29,2.555,22.136h-.8a.755.755,0,1,0,0,1.51H19.871a.755.755,0,1,0,0-1.51h-.8a6.679,6.679,0,0,0-1.48-3.487,16.853,16.853,0,0,0-2.521-2.431c-1.072-.891-1.993-1.661-1.993-2.385,0-.543.543-1.132,1.23-1.744Zm3.3-9.579a4.529,4.529,0,1,1-4.529,4.529,4.529,4.529,0,0,1,4.529-4.529Zm-.06,19.626H4.08a5.224,5.224,0,0,1,.928-2.265H16.6a5.25,5.25,0,0,1,.944,2.265Zm-5.978-8.3c0,1.434,1.23,2.453,2.536,3.54.385.317.77.649,1.147.989H6.375c.377-.347.762-.664,1.14-.981,1.306-1.087,2.544-2.114,2.544-3.548S8.82,11.371,7.514,10.284C6.042,9.062,4.4,7.688,4.08,5.529h7.684a6.221,6.221,0,0,0-.2,1.51A5.987,5.987,0,0,0,13.153,11.1,3.873,3.873,0,0,0,11.568,13.832Z",
    transform: "translate(0 0)",
    fill: "#f57224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.019,7.265H23.51V5.755a.755.755,0,1,0-1.51,0V8.019a.755.755,0,0,0,.755.755h2.265a.755.755,0,1,0,0-1.51Z",
    transform: "translate(-5.148 -0.981)",
    fill: "#f57224"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaiting);
export default __webpack_public_path__ + "static/media/icon-waiting.ab959028b79f35e542aea825f7bc382e.svg";
export { ForwardRef as ReactComponent };